import { createInstance } from 'i18next';
import ICU from 'i18next-icu';
import React, { createContext, useContext, useMemo } from 'react';
import de from './locales/de-DE/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr-FR/translation.json';
import it from './locales/it-IT/translation.json';
import pt from './locales/pt-BR/translation.json';
import tr from './locales/tr-TR/translation.json';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const DEFAULT_LANGUAGE = 'en';
export const I18N_PLACEHOLDER = '__placeholder__';
function createTranslationsInstance() {
  let {
    language = DEFAULT_LANGUAGE
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const instance = createInstance({
    appendNamespaceToCIMode: true,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    lng: language,
    ns: ['translation'],
    resources: {
      de: {
        translation: de
      },
      en: {
        translation: en
      },
      es: {
        translation: es
      },
      fr: {
        translation: fr
      },
      it: {
        translation: it
      },
      pt: {
        translation: pt
      },
      tr: {
        translation: tr
      }
    },
    returnNull: false
  });
  instance.use(ICU).init();
  return instance;
}
const defaultI18NextInstance = createTranslationsInstance();
const TranslationsContext = createContext({
  language: DEFAULT_LANGUAGE
});
export const TranslationsProvider = _ref => {
  let {
    children,
    language = DEFAULT_LANGUAGE
  } = _ref;
  const i18NextInstance = useMemo(() => createTranslationsInstance({
    language
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const contextValue = useMemo(() => ({
    i18NextInstance,
    language
  }), [i18NextInstance, language]);
  return ___EmotionJSX(TranslationsContext.Provider, {
    value: contextValue
  }, children);
};
export function useTranslation() {
  var _i18NextInstance$t;
  const {
    i18NextInstance,
    language
  } = useContext(TranslationsContext);
  return {
    i18n: i18NextInstance !== null && i18NextInstance !== void 0 ? i18NextInstance : defaultI18NextInstance,
    language,
    t: (_i18NextInstance$t = i18NextInstance === null || i18NextInstance === void 0 ? void 0 : i18NextInstance.t) !== null && _i18NextInstance$t !== void 0 ? _i18NextInstance$t : defaultI18NextInstance.t
  };
}